<main *ngIf="isLoggedIn() || isMobile">
    <router-outlet></router-outlet>
</main>
